import React, { createContext, useContext, useState } from 'react';

const DragDropContext = createContext();

export const useDragDrop = () => {
  const context = useContext(DragDropContext);
  if (!context) {
    throw new Error('useDragDrop must be used within DragDropProvider');
  }
  return context;
};

export const DragDropProvider = ({ children }) => {
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedType, setDraggedType] = useState(null); // 'document', 'folder', 'file'
  const [dropTarget, setDropTarget] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [draggedFiles, setDraggedFiles] = useState([]);

  const startDrag = (item, type) => {
    setDraggedItem(item);
    setDraggedType(type);
    setIsDragging(true);
  };

  const startFileDrag = (files) => {
    setDraggedFiles(files);
    setDraggedType('file');
    setIsDragging(true);
  };

  const endDrag = () => {
    setDraggedItem(null);
    setDraggedType(null);
    setDropTarget(null);
    setIsDragging(false);
    setDraggedFiles([]);
  };

  const setDropTargetFolder = (folderID) => {
    setDropTarget(folderID);
  };

  const value = {
    draggedItem,
    draggedType,
    dropTarget,
    isDragging,
    draggedFiles,
    startDrag,
    startFileDrag,
    endDrag,
    setDropTargetFolder,
  };

  return (
    <DragDropContext.Provider value={value}>
      {children}
    </DragDropContext.Provider>
  );
};

export default DragDropProvider;